import React, {Component} from "react";
import FormGroupSelectInput from "../formGroupSelectInput";
import Button from "../button";
import _ from "lodash";
import {withRouter} from "react-router";
import { LEGAL_ADVICE_TEXT } from "../../helpers/variables";
import { PERCENTAGE_PREMIUMS_AVAILABLE } from "../../helpers/variables";
import { PS_TYPE_PERCENTAGE, PS_TYPE_PERCENTAGE_CASE_TYPES } from "../../helpers/constants";

const getCaseTypesOptions = (caseTypes,premiumSettingType) => {
    if(premiumSettingType === PS_TYPE_PERCENTAGE && PERCENTAGE_PREMIUMS_AVAILABLE){
        return [{key: '', value: ''}, ...caseTypes.filter(ct => PS_TYPE_PERCENTAGE_CASE_TYPES.includes(ct.machineName)).map(caseType => {
            return {
                key: caseType.id,
                value: caseType.name
            }
        })]
    }
    else{
        return [{key: '', value: ''}, ...caseTypes.map(caseType => ({
            key: caseType.id,
            value: caseType.name
        }))]
    }
};

const getSubCaseTypesOptions = (subCases, selectedCaseTypeId) => {
    return [{key: '', value: ''}, ..._.filter(subCases, item => {
        return  item.caseTypeId.toString() === selectedCaseTypeId
    }).map(item => ({key: item.id, value: item.name}))]
};

const getGroupSubCaseTypesOptions = (caseTypes, selectedCaseTypeId) => {
    const o = [];
    _.forEach(caseTypes, ctype => {
        if(ctype.id.toString() === selectedCaseTypeId){
            _.forEach(ctype.subCaseTypes, sctype => {
                o.push(sctype)
            })
        }
    });
    return [{key: '', value: ''},...o.map(item => {return {key: item.id, value: item.name}})];
};


class PremiumSettingsCopyForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            solicitorGroup: "",
            workSource: "",
            caseType: "",
            subCaseType: "",
        }
    }

    onGroupChange = (evt) => {
        const groupId = evt.target.value;
        if(groupId !== ""){
            this.props.requestGetSolicitorGroupWorkSources(groupId);
            this.props.getSolicitorGroupCaseTypes(groupId);
        }

        this.setState({
            ...this.state,
            solicitorGroup: groupId,
            caseType: "",
            subCaseType: ""
        })
    };

    onWorkSourceChange = (evt) => {
        this.setState({
            ...this.state,
            workSource: evt.target.value
        })
    };

    onCaseChange = (evt) => {
        this.setState({
            ...this.state,
            caseType: evt.target.value,
            subCaseType: ""
        })
    };

    onSubCaseChange = (evt) => {
        this.setState({
            ...this.state,
            subCaseType: evt.target.value
        })
    };

    onCopy = () => {
        const copyConfigQueryParam  = this.props.stagedId!=''?
        `psId=${this.props.stagedId}`
        :
        `psId=${this.props.premiumSettingsId}`

        const matchedGroup = this.props.groupOptions
            .find(option => option.key.toString() === this.state.solicitorGroup);
        const matchedWorkSource = this.props.workSourcesOptions
            .find(option => option.key.toString() === this.state.workSource);
        // const matchedCaseType = this.props.caseTypes
        //     .find(type => type.id.toString() === this.state.caseType);
        // const matchedSubCaseType = this.props.subCaseTypes
        //     .find(type => type.id.toString() === this.state.caseType);

        this.props.changeNewPremiumStoreSettings("selectedSolicitorGroup", this.state.solicitorGroup);
        this.props.changeNewPremiumStoreSettings("selectedWorksource", this.state.workSource);
        this.props.changeNewPremiumStoreSettings("selectedCaseType", this.state.caseType );
        this.props.changeNewPremiumStoreSettings("selectedSubCaseType", this.state.subCaseType);

        if(
            matchedGroup
            && matchedGroup.key
        ){
            this.props.changeNewPremiumStoreSettings("selectedSolicitorGroupName", matchedGroup.value);
        }

        if(matchedWorkSource){
            this.props.changeNewPremiumStoreSettings("selectedWorkSourceName", matchedWorkSource.value);

        }

        this.props.stagedId ?
        this.props.history.push(`premium-settings/new-staged-premium-settings?${copyConfigQueryParam}`)
        :
        this.props.history.push(`premium-settings/new-premium-settings?${copyConfigQueryParam}`)
    };

    render(){
        const {
            onCancel,
            groupCaseAndSubTypes,
            caseTypes,
            subCaseTypes,
            groupOptions,
            workSourcesOptions,
            premiumSettingType
        } = this.props;

        const caseTypesOptions = this.state.solicitorGroup ?
            getCaseTypesOptions(groupCaseAndSubTypes,premiumSettingType) : getCaseTypesOptions(caseTypes,premiumSettingType);
        const subCaseTypesOptions = this.state.solicitorGroup?
            getGroupSubCaseTypesOptions(groupCaseAndSubTypes, this.state.caseType) : getSubCaseTypesOptions(subCaseTypes, this.state.caseType);

        return (
            <form className={"form-horizontal"}>
                <FormGroupSelectInput
                    Label={`${LEGAL_ADVICE_TEXT} Group`}
                    LeftWrapper="col-sm-3"
                    Value={this.state.solicitorGroup}
                    Name="solicitorGroup"
                    HandleInputChange={this.onGroupChange}
                    Options={groupOptions}
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
                {this.state.solicitorGroup !== "" && (
                    <FormGroupSelectInput
                        Label="Work source"
                        LeftWrapper="col-sm-3"
                        Value={this.state.workSource}
                        Name="workSource"
                        HandleInputChange={this.onWorkSourceChange}
                        Options={workSourcesOptions}
                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                        SelectStyle={'form-control formGroupSelectInput-select'}
                    />
                )}
                <FormGroupSelectInput
                    Label="Case Type"
                    LeftWrapper="col-sm-3"
                    Value={this.state.caseType}
                    Name="caseType"
                    HandleInputChange={this.onCaseChange}
                    Options={caseTypesOptions}
                    Required
                    CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                    SelectStyle={'form-control formGroupSelectInput-select'}
                />
                {subCaseTypesOptions.length > 1 && (
                    <FormGroupSelectInput
                        Label="Sub Case Type"
                        LeftWrapper="col-sm-3"
                        Value={this.state.subCaseType}
                        Name="subCaseType"
                        HandleInputChange={this.onSubCaseChange}
                        Options={subCaseTypesOptions}
                        CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
                        SelectStyle={'form-control formGroupSelectInput-select'}
                    />
                )}
                <div className={"form-group"}>
                    <div className={"col-sm-6 col-sm-offset-3"}>
                        <Button
                            disabled={this.state.caseType === ""}
                            clickHandler={this.onCopy}
                            wrapper="btn-wrapper-forForms"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Create New Based On Current"
                        />
                        <Button
                            wrapper="btn-wrapper-forForms"
                            btnType="button"
                            clickHandler={onCancel}
                            btnStyle={'btn btn-primary btn-xs sharp blue'}
                            label="Cancel"/>
                    </div>
                </div>
            </form>
        )
    }
}

export default withRouter(PremiumSettingsCopyForm);